import Vue from "vue";
import Vuelidate from "vuelidate";
import Vuex from 'vuex'
import store from "./store";
import './bootstrap'
import 'slick-carousel/slick/slick.min';

Vue.use(Vuelidate);
Vue.use(Vuex);

Vue.component('modal', require('./components/Modal.vue').default);
Vue.component('thanks', require('./components/Thanks.vue').default);
Vue.component('quiz', require('./components/Quiz.vue').default);
Vue.component('thanks-quiz', require('./components/ThanksQuiz.vue').default);
Vue.component('start-page-quiz', require('./components/StartPageQuiz.vue').default);
Vue.component('last-step', require('./components/LastStep.vue').default);
Vue.component('form-home', require('./components/FormHome.vue').default);
Vue.component('form-home-footer', require('./components/FormHomeFooter.vue').default);


const app = new Vue({
    store,
    el: '#app',
    computed:{
        isThanks(){
            return this.$store.getters.isThanks
        },
        isThanksQuiz(){
            return this.$store.getters.isQuizThanks
        },
        isStartPage(){
            return this.$store.getters.getStartPage
        }
    },
    created: function(){
        if(!sessionStorage.getItem('urlQueryString'))
            sessionStorage.setItem('urlQueryString', window.location.href);
  
    }
});
